// @flow
import SMRestClient from 'lib/SMRestClient';

class SMEnterpriseResource {
  static inquiry(formData: Object, completion: Function) {
    const url = "/1/enterprise_inquiries.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }
}
export default SMEnterpriseResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMEnterpriseResource.js